import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';


export const AlertDialogs = (props: any) => {

  const handleClose = (action: string) => {
    props.setOpen(false);
    props.getConfirmResponse(action);
  };
  
  return (
    <React.Fragment>
        <Dialog
          open={props.open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ borderRadius: '30px !important', backgroundColor: "transparent" }}
          className="confirmBoxDialog"
        >
          <DialogTitle className="bgConfirmPopup popupHeader" id="alert-dialog-title" style={{ color: '#fff' }}>{props.title} <span style={{float: "right", cursor: "pointer"}} onClick={() =>props.setOpen(false)}><img src={"/icons/close.png"} /></span></DialogTitle>
          <div style={{ borderTop: '1px solid #313838' }}></div>
          <DialogContent className="bgConfirmPopup">
            <DialogContentText id="alert-dialog-description" style={{ color: '#B4B7B8' }}>
              {/* <div dangerouslySetInnerHTML={{ __html: props.message }} /> */}
            {typeof props.message === 'string' ? (
              <div dangerouslySetInnerHTML={{ __html: props.message }} />
            ) : (
              props.message
            )}

            </DialogContentText>
          </DialogContent>
          <DialogActions className='bgConfirmPopup' style={{paddingRight: "20px", paddingBottom: "20px"}}>
            <Button style={{  textTransform: "none",border: "1px solid #17b2eb",borderRadius: "30px", color: "#17b2eb" }} className="hoverBtn" onClick={() => handleClose(props.button1)}>{props.button1}</Button>
            <Button style={{ textTransform: "none",border: "1px solid #17b2eb",borderRadius: "30px", color: "#000",backgroundColor: "#17b2eb" }} className="popupBtnActive" onClick={() => handleClose(props.button2)} autoFocus>{props.button2}</Button>
          </DialogActions>
        </Dialog>
    </React.Fragment>
  );
}
